'use client';

import { useEffect } from 'react';

import type { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

const Home = () => {
  useEffect(() => {
    window.location.href = 'https://scorenco.com/clubs/widgets';
  }, []);

  return <div />;
};

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'fr', [
      'snc-components',
      'snc-core',
      'common',
    ])),
  },
});

export default Home;
